import { useNavigate } from "react-router-dom";

export default function NextBestAction({ score }) {

  const navigate = useNavigate();
  const isHighScore = score >= 60;

  return (
    <section className="rounded-2xl p-8 text-white shadow-xl bg-gradient-to-r from-indigo-600 to-blue-600">

      {/* TITLE */}
      <h2 className="text-2xl font-semibold">
        {isHighScore
          ? "Your resume is ready for interviews 🚀"
          : "Your resume needs improvement"}
      </h2>

      {/* DESCRIPTION */}
      <p className="text-sm mt-3 text-white/90 max-w-xl">
        {isHighScore
          ? "Your resume is ATS-friendly. A few refinements can improve recruiter response."
          : "Fixing high-impact issues can increase your chances of getting shortlisted."}
      </p>

      {/* SCORE BOOST */}
      {!isHighScore && (
        <p className="mt-3 text-sm text-white/80">
          🚀 Improve your score to{" "}
          <span className="font-bold">
            {Math.min(score + 20, 95)}%
          </span>
        </p>
      )}

      {/* BUTTONS */}
      <div className="flex gap-4 mt-6 flex-wrap">

        {!isHighScore ? (
          <>
            <button
              onClick={() => navigate("/candidate/resume-editor")}
              className="bg-white text-blue-600 font-semibold px-6 py-2 rounded-lg hover:bg-white/90 transition"
            >
              Improve Resume Now
            </button>

            <button
              onClick={() => window.scrollTo({ top: 600, behavior: "smooth" })}
              className="border border-white text-white px-6 py-2 rounded-lg hover:bg-white/10 transition"
            >
              See Detailed Feedback
            </button>
          </>
        ) : (
          <button
           onClick={() => navigate("/candidate/resume-editor")}
            className="bg-white text-blue-600 font-semibold px-6 py-2 rounded-lg hover:bg-white/90 transition"
          >
            Improve & Download Resume 🚀
          </button>
        )}

      </div>

    </section>
  );
}